import config from '@/config'
import { DocData, PageSum } from '@/types'

/** 默认页面统计 */
export function getDefaultPageSum(): PageSum {
  const { width, height } = config.page

  return {
    minWidth: width,
    minHeight: height,
    maxWidth: width,
    maxHeight: height
  }
}

/** 获取文档页面统计 */
export function getDocPageSum(doc?: DocData): PageSum {
  if (!doc?.pages.length) return getDefaultPageSum()

  const { pages } = doc
  const pageWidths = pages.map(p => p.w).filter(w => !!w)
  const pageHeights = pages.map(p => p.h).filter(h => !!h)

  return {
    minWidth: Math.min(...pageWidths),
    minHeight: Math.min(...pageHeights),
    maxWidth: Math.max(...pageWidths),
    maxHeight: Math.max(...pageHeights)
  }
}
